import type { Account } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetAccount } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useAccountSWRKey } from "./useAccountSWRKey"

export function useAccount(): SWRResponse<Account> {
  const accountSWRKey = useAccountSWRKey()
  const getAccount = useGetAccount()

  const getAccountData = useMemo(
    () => !getAccount ? null : (async () => {
      const response = await getAccount()
      return response.data.account
    }),
    [getAccount],
  )

  return useSWR<Account>(
    accountSWRKey,
    getAccountData,
  )
}
